document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.Quiz-block');
  let currentSectionIndex = 0;

  function showSection(index) {
    sections.forEach((section, i) => {
      section.style.display = (i === index) ? 'block' : 'none';
    });
  }

  document.querySelectorAll('.quiz-next').forEach(button => {
    button.addEventListener('click', (event) => {
      // Highlight the clicked button
      event.target.classList.add('highlighted');

      if (currentSectionIndex < sections.length - 1) {
        currentSectionIndex++;
        showSection(currentSectionIndex);
      }

      // Remove highlight after a short delay
      setTimeout(() => {
        event.target.classList.remove('highlighted');
      }, 500); // Adjust duration as needed
    });
  });

  document.querySelectorAll('.quiz-prev').forEach(button => {
    button.addEventListener('click', () => {
      if (currentSectionIndex > 0) {
        currentSectionIndex--;
        showSection(currentSectionIndex);
      }
    });
  });

  // Initial display
  showSection(currentSectionIndex);
});

document.addEventListener('DOMContentLoaded', function () {
  // Mapping of button IDs to desired text to store
  const buttonTextMapping = {
    'gtmquizq5cantsleep': 'fall asleep quickly.',
    'gtmquizq5wakeupatnight': 'stay asleep through the night.',
    'gtmquizq5waketoearly': 'wake up on time.'
  };

  const buttons = document.querySelectorAll('.quiz-getvalue');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      // Get the ID of the clicked button
      const buttonId = this.id;

      // Retrieve the text from the mapping
      const selectedText = buttonTextMapping[buttonId] || 'sleep';

      // Store the text in local storage
      localStorage.setItem('quizSelectedText', selectedText);

      console.log(`Saved: ${selectedText}`); // For debugging purposes
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Fetch the stored text from local storage
  const retrievedText = localStorage.getItem('quizSelectedText');
  
  if (retrievedText) {
    console.log(`Retrieved: ${retrievedText}`); // For debugging purposes
    
    // Use the retrieved text as needed
    // For example, display it on the page
    const resultDisplayElement = document.getElementById('result-display'); // Assume there's an element to display the text
    if (resultDisplayElement) {
      resultDisplayElement.textContent = retrievedText;
    }
    
    // Optionally, clear the stored value
    // localStorage.removeItem('quizSelectedText');
  } else {
    console.log('No selection found.');
  }
});